import { render } from "./TableRowItem.vue?vue&type=template&id=57d9f110"
import script from "./TableRowItem.vue?vue&type=script&lang=ts"
export * from "./TableRowItem.vue?vue&type=script&lang=ts"
script.render = render

export default script